<template>
  <div class="w-full md:grid md:place-items-center">
    <div class="md:w-1/2 text-root-2 mt-6 w-full mb-8 ml-4 md:ml-0 md:mb-0">
      <div
        @click="goBack"
        v-if="currentSwapBeneficiaryDetails"
        class="flex items-center border rounded-full w-20 gap-x-2 text-gray-90 border-gray-90 px-2 py-1 text-xs cursor-pointer justify-center"
      >
        <i class="el-icon-back"></i>
        <p class="font-light">Back</p>
      </div>
    </div>
    <div
      class="mx-3 md:mx-0 lg:w-1/2 text-root-2 max-w-3xl md:mt-10 rounded-2xl drop-shadow"
    >
      <swap-form
        v-if="!showConfirmationScreens"
        @next="showConfirmationScreensHandler"
      />
      <confirmation-screens v-else @close="closeConfirmationScreensHandler" />
    </div>
  </div>
</template>

<script>
import getSwapPairsAssetsDetails from '@/mixins/bridge.js'
export default {
  mixins: [getSwapPairsAssetsDetails],
  data () {
    return {
      showConfirmationScreens: false
    }
  },
  methods: {
    goBack () {
      if (this.currentConfirmationScreenStep < 1) {
        this.$store.dispatch('bridge/setCurrentSwapBeneficiaryDetails', null)
        this.showConfirmationScreens = false
      } else if (this.currentConfirmationScreenStep === 2) {
        this.$store.dispatch('bridge/clearMainSwapState')
        this.showConfirmationScreens = false
      } else {
        this.currentConfirmationScreenStep--
      }
    },
    showConfirmationScreensHandler () {
      this.showConfirmationScreens = true
      this.currentConfirmationScreenStep = 1
    },
    closeConfirmationScreensHandler () {
      this.showConfirmationScreens = false
    }
  },
  components: {
    SwapForm: () => import('@/components/v2/bridge/forms/SwapForm.vue'),
    ConfirmationScreens: () =>
      import('@/components/v2/bridge/confirmationScreens/index.vue')
  },
  computed: {
    currentSwapBeneficiaryDetails () {
      return this.$store.state.bridge.currentSwapBeneficiaryDetails
    },
    currentConfirmationScreenStep: {
      get: function () {
        return this.$store.state.bridge.currentConfirmationScreenStep
      },
      set: function (newValue) {
        this.$store.dispatch(
          'bridge/setCurrentConfirmationScreenStep',
          newValue
        )
      }
    }
  },
  async created () {
    await this.getSwapPairsAssetsDetails()
  },
  destroyed () {
    this.$store.dispatch('bridge/clearMainSwapState')
  }
}
</script>
